
<!---progress bar ngx0-->
<ng-progress [spinnerPosition]="sPosition" #progressBar></ng-progress> 
